import React from 'react';
import ReactDOM from 'react-dom';
// CRA 4 ships PostCSS 7 which can't process Tailwind 3 directives, so we
// pre-compile `tailwind.css` → `tailwind.compiled.css` via the Tailwind CLI
// (see `yarn build:css` / `yarn build` in package.json) and import the result.
// Legacy SCSS is intentionally NOT imported — screens are being rebuilt in Tailwind.
import './tailwind.compiled.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
